export type Locale = "fi" | "en" | "sv";

export interface SharedConfig {
  readonly version: string;
  readonly defaultLocale: Locale;
  readonly defaultTimezone: string;
}

export const sharedConfig: SharedConfig = {
  version: "0.1.0-phase0",
  defaultLocale: "fi",
  defaultTimezone: "Europe/Helsinki",
};
